import { createContext, useState, useEffect } from "react";
import Cookies from "universal-cookie";
import { getCompanyDetails } from "../utils/apis/company/getCompanyDetails";
import sessionCache from "../utils/sessionCache";

export const Context = createContext();

export const ContextProvider = ({ children }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isPaymentFormModalOpen, setIsPaymentFormModalOpen] = useState(false);
    const [isSideNavigationOpen, setIsSideNavigationOpen] = useState(false);
    const [isAddEmployeeSuccessModalOpen, setIsAddEmployeeSuccessModalOpen] = useState(false);
    const [isUpdateEmployeeSuccessModalOpen, setIsUpdateEmployeeSuccessModalOpen] = useState(false);
    const [isResetPasswordModalOpen, setIsResetPasswordModalOpen] = useState(false);
    const [isSelectCompaniesModalOpen, setIsSelectCompaniesModalOpen] = useState(false);
    const [isPayslipDetailsModalOpen, setIsPayslipDetailsModalOpen] = useState(false);
    const [isAddEmployeeModalOpen, setIsAddEmployeeModalOpen] = useState(false);
    const [isAddDepartmentModalOpen, setIsAddDepartmentModalOpen] = useState(false);
    const [isPlansAndPricingModalOpen, setIsPlansAndPricingModalOpen] = useState(false);
    const [isEmployeeBulkUploadModalOpen, setIsEmployeeBulkUploadModalOpen] = useState(false);
    const [isDepartmentBulkUploadModalOpen, setIsDepartmentBulkUploadModalOpen] = useState(false);
    const [isManageEmployeeModalOpen, setIsManageEmployeeModalOpen] = useState(false);
    const [isEditPlanModalOpen, setIsEditPlanModalOpen] = useState(false);
    const [isWalletFundingModalOpen, setIsWalletFundingModalOpen] = useState(false);
    // Bumped after a successful complete-funding call so any component
    // reading wallet info (e.g. the balance card) knows to refetch, since
    // complete-funding itself doesn't return an updated balance.
    const [walletRefreshTrigger, setWalletRefreshTrigger] = useState(0);
      const [activeCompanyId, setActiveCompanyId] = useState(() => {
    const cookie = new Cookies();
    return cookie.get("COMPANY_ID") || null;
  });
    // Initialise from sessionStorage so the value is available on the very
    // first render (avoids the Wallet link flash-of-hidden-content).
    const [activeCompanyDetails, setActiveCompanyDetails] = useState(() => {
      if (!activeCompanyId) return null;
      return sessionCache.get(`companyDetails_${activeCompanyId}`) || null;
    });

    useEffect(() => {
      const cookie = new Cookies();
      const TOKEN = cookie.get("TOKEN");
      if (!activeCompanyId || !TOKEN) return;

      // Serve cached value immediately (already done in useState initialiser),
      // then do a background refresh to keep the cache up-to-date.
      getCompanyDetails(TOKEN, activeCompanyId)
        .then((res) => {
          const details = res?.data || res;
          setActiveCompanyDetails(details);
          sessionCache.set(`companyDetails_${activeCompanyId}`, details);
        })
        .catch((err) => console.error("Failed to fetch company details in Context:", err));
    }, [activeCompanyId]);

    return (
        <Context.Provider value={{
            isMenuOpen,
            setIsMenuOpen,
            isPaymentFormModalOpen,
            setIsPaymentFormModalOpen,
            isSideNavigationOpen,
            setIsSideNavigationOpen,
            isAddEmployeeSuccessModalOpen,
            setIsAddEmployeeSuccessModalOpen,
            isUpdateEmployeeSuccessModalOpen,
            setIsUpdateEmployeeSuccessModalOpen,
            isResetPasswordModalOpen,
            setIsResetPasswordModalOpen,
            isSelectCompaniesModalOpen,
            setIsSelectCompaniesModalOpen,
            isPayslipDetailsModalOpen,
            setIsPayslipDetailsModalOpen,
            isPlansAndPricingModalOpen,
            setIsPlansAndPricingModalOpen,
            isAddEmployeeModalOpen,
            setIsAddEmployeeModalOpen,
            isAddDepartmentModalOpen,
            setIsAddDepartmentModalOpen,
            isEmployeeBulkUploadModalOpen,
            setIsEmployeeBulkUploadModalOpen,
            isDepartmentBulkUploadModalOpen,
            setIsDepartmentBulkUploadModalOpen,
            isManageEmployeeModalOpen,
            setIsManageEmployeeModalOpen,
            isEditPlanModalOpen,
            setIsEditPlanModalOpen,
            isWalletFundingModalOpen,
            setIsWalletFundingModalOpen,
            walletRefreshTrigger,
            setWalletRefreshTrigger,
            activeCompanyId, setActiveCompanyId,
            activeCompanyDetails, setActiveCompanyDetails
        }}>
            {children}
        </Context.Provider>
    )
}